import { isEmpty, orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import getCollection from '../../utils/db/getCollection'
import Icon from '../../ui/Icon/Icon'
import './ServicePrice.sass'

function ServicePriceTiles({ categoryId }) {
  const [services, setServices] = useState(null)

  useEffect(() => {
    getCollection({
      path: 'settings/price/services',
      docIdName: 'serviceId',
      whereQueries: [{ fieldPath: 'isDeleted', op: '!=', value: true }],
    }).then((result) =>
      setServices(
        orderBy(
          result.filter((r) => r.categoryId === categoryId),
          ['pos'],
          ['asc']
        )
      )
    )
  }, [categoryId])

  return (
    <div className="ServicePrice">
      {!isEmpty(services) && <ServiceTile services={services} />}
    </div>
  )
}

function ServiceTile({ categoryId, services }) {
  return (
    <div id={`category-${categoryId}`} className={`ServiceTile`}>
      <div className="Tile-Head">
        <span className="Title">Прайс</span>
      </div>

      <div className="ProductsTiles">
        {services.map((s) => (
          <div className="ProductTile">
            <div className="Avatar">
              <img src={s.photoUrl} alt={s.title} />
            </div>
            <div className="Title">{s.title}</div>
            <div className="Quantity-Price">
              <div className="Quantity">Кількість: {s.quantity}</div>
              <div className="Price">{s.price} грн.</div>
            </div>
          </div>
        ))}
      </div>

      {/* <div className="Tile-Body">
        <div className="PriceTable">
          <table>
            <thead>
              <tr>
                <th>Назва послуги</th>
                <th className="Price">Вартість</th>
              </tr>
            </thead>
            <tbody>
              {services.map((s) => (
                <tr key={s.serviceId}>
                  <td>{s.title}</td>
                  <td className="Price">{s.price} грн</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
    </div>
  )
}

export default ServicePriceTiles
